import Navbar from '@/pages/home/components/Navbar';
import Hero from '@/pages/home/components/Hero';
import LiveTicker from '@/pages/home/components/LiveTicker';
import LiveNow from '@/pages/home/components/LiveNow';
import Collections from '@/pages/home/components/Collections';
import HostRanking from '@/pages/home/components/HostRanking';
import Shorts from '@/pages/home/components/Shorts';
import Categories from '@/pages/home/components/Categories';
import Trust from '@/pages/home/components/Trust';
import Faq from '@/pages/home/components/Faq';
import CtaBand from '@/pages/home/components/CtaBand';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <LiveTicker />
        <LiveNow />
        <Collections />
        <HostRanking />
        <Shorts />
        <Categories />
        <Trust />
        <Faq />
        <CtaBand />
      </main>
      <Footer />
    </div>
  );
}